require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-ie-project-checklist.json") })
        }
      }, "path---en-us-update-ie-project-checklist");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-ie-project-checklist!./.cache/json/en-us-update-ie-project-checklist.json
// module id = 752
// module chunks = 231608221292675